<div *ngIf="!modoPago">
  <div class="container-aportes-pagos">
    <div class="primas-grid">
      <div style="margin-bottom:20px" *ngIf="checkOfContinuidad()">
        <!-- <div style="margin-bottom:20px"> -->
        <app-error-banner
          [title]="'LO SENTIMOS'"
          [subtitle]="
            'No puedes pagar primas de una misma póliza dejando pagos de períodos anteriores pendientes.'
          "
        ></app-error-banner>
      </div>
      <div style="margin-bottom: 1.1875rem">
        <app-mini-loader *ngIf="loading"></app-mini-loader>
        <app-error *ngIf="error"></app-error>
        <app-card-pagar-producto
          *ngIf="data"
          [displayedColumns]="displayedColumns"
          [displayedColumnsACobranza]="displayedColumnsACobranza"
          [codigoRamo]="codigoRamo"
          [resumen]="resumen"
          [showTotalResumen]="showTotalResumen"
          [showPeriodicas]="showPeriodicas"
          [showEsporadicas]="showEsporadicas"
          [showMode]="showModeAviso"
          [producto]="data"
          [pagoSeleccionado]="pagoSeleccionadoParent"
          [tabLabel]="tabLabel"
          ($onRealizarAporte)="onRealizarAporte($event)"
          ($onChangeAviso)="onChangeAviso($event)"
        >
        </app-card-pagar-producto>
        <div class="container-message-2" *ngIf="msgAporteCUI">
          <table>
            <tr>
              <td>
                <mat-icon>info_outline</mat-icon>
              </td>
              <td>
                <u>Información Importante:</u><br />
                <ol>
                  <li>
                    El monto máximo permitido para realizar aportes diarios a
                    través de tarjeta de crédito es de $1 millón.
                  </li>
                  <li>
                    Para realizar aportes superiores a este monto, utiliza
                    tarjeta de débito o pago directo en caja de la Compañía.
                  </li>
                </ol>
              </td>
            </tr>
          </table>
        </div>
        <app-error-banner
          *ngIf="errorAporteCUIMin"
          [subtitle]="
            'Para realizar aportes de dinero con este medio de pago, el monto mínimo ingresado debe ser superior a $1.000.'
          "
        ></app-error-banner>
        <app-error-banner
          *ngIf="errorAporteCUIMax"
          [subtitle]="
            'Monto ingresado supera el máximo permitido con el medio de pago seleccionado.'
          "
        ></app-error-banner>
      </div>
    </div>
    <span *ngIf="!showTotalResumen" class="value hidden-value resumen-grid">{{
      getTotalMonto() | number
    }}</span>
    <div
      class="resumen-container resumen-grid"
      *ngIf="showTotalResumen && !error && showModeResumen"
    >
      <div appKeepVerticalScroll class="resumen">
        <h4 style="margin: 0px">RESUMEN</h4>
        <p class="labelResumen">Primas seleccionadas:</p>
        <div
          class="total-mount"
          style="display: grid;grid-template-columns: 1fr 1fr;"
        >
          <div>
            <h4 style="margin: 0px">
              TOTAL
            </h4>
          </div>
          <div style="margin: 0px;text-align: end">
            <span class="label">$</span>
            <span class="value">{{ getTotalMonto() | number }}</span>
          </div>
        </div>
        <button
          class="button-pagar"
          [disabled]="getTotalMonto() <= 0 || checkOfContinuidad()"
          mat-flat-button
          (click)="onPagar()"
        >
          Pagar
        </button>
      </div>
    </div>
  </div>
</div>

<div>
  <app-webpay
    *ngIf="modoPago"
    [dataAPagar]="checkedPays"
    ($closeWebPay)="closeWebPay($event)"
    [isTokuOptionVisible]="true"
  ></app-webpay>
</div>
